<template>
  <div
    class="w-full h-full rounded-[5px] overflow-hidden desktop-only"
    :id="`video-${index + 1}`"
  >
    <video
      id="videoRef"
      ref="videoRef"
      class="w-full h-full opacity-0 video-js vjs-default-skin"
    >
      <source :src="src" type="video/mp4" />
    </video>
  </div>
</template>

<script setup>
import videojs from "video.js";
import { useMainStore } from "~/store";

const props = defineProps({
  src: {
    type: String,
    required: true,
    default: "",
  },
  poster: {
    type: String,
    required: true,
    default: "",
  },
  index: {
    type: Number,
    required: true,
    default: 0,
  },
});

const emit = defineEmits();
const store = useMainStore();

const isPlaysInline = ref(true);
const videoRef = ref(null);
const clonedElement = ref(null);
const modalId = ref("video-player");
let player;

function onModalOpened(isFullscreen = false) {
  clonedElement.value = document.getElementById("videoRef");
  // console.log("isPlaysInline.value", document.getElementById("videoRef"));
  player = videojs(
    document.getElementById("videoRef"),
    {
      playbackRates: [0.5, 1, 1.5, 2],
      controls: true,
      autoplay: "play",
      preload: "auto",
      language: store.locale,
      fluid: false,
      responsive: true,
      experimentalSvgIcons: true,
      userActions: {
        hotkeys: true,
      },
      playsinline: isPlaysInline.value,
      preferFullWindow: false,
      disablePictureInPicture: true,
      enableDocumentPictureInPicture: false,
      enableSmoothSeeking: true,
      controlBar: {
        remainingTimeDisplay: {
          displayNegative: true,
        },
        skipButtons: {
          backward: 10,
          forward: 10,
        },
      },
    },
    function () {
      player.controlBar.removeChild("PictureInPictureToggle");
      document.querySelector(".video-js").classList.remove("opacity-0");
      document.querySelector(".video-js").classList.add("opacity-100");
      document.querySelector(".vjs-big-play-button").click();
    }
  );
  if (props.poster) {
    player.poster(props.poster);
  }
}

onMounted(() => {
  onModalOpened();
});
// Optional: unlock on fullscreen exit

const exitFullscreen = async () => {
  if (!document.fullscreenElement && screen.orientation?.unlock) {
    screen.orientation.unlock();
  }
};
document.addEventListener("fullscreenchange", exitFullscreen);
onBeforeUnmount(() => {
  document.removeEventListener("fullscreenchange", exitFullscreen);
  if (player) {
    player.dispose();
  }
});
</script>
<style >
@import "video.js/dist/video-js.css";

.desktop-only .video-js .vjs-tech,
.desktop-only .vjs-poster img {
  @apply !object-contain lg:!object-cover  object-center;
}

/* play track */
.desktop-only .video-js .vjs-play-progress .vjs-svg-icon {
  @apply !top-[-3.2px];
}
.desktop-only .video-js .vjs-progress-control:hover .vjs-svg-icon {
  @apply !top-[-5.2px];
}

/* voluem */
.vjs-slider-horizontal .vjs-volume-level .vjs-svg-icon {
  @apply top-[1.5px];
}
</style>